module.exports = __webpack_public_path__ + "img/sqtk_icon.ff4247de.svg";